import React from 'react'
import { QueryClient } from 'react-query'
import { dehydrate } from 'react-query/hydration'
import { GetServerSideProps } from 'next'
import { MainLayout } from 'src/features/layouts'
import { newLandingApi, TRANSLATE } from 'src/features/new-landing/common'

import { SEO_TEXTS, sharedApi } from 'src/shared'
import { QuestionsList } from 'src/features/questions'

export const getServerSideProps: GetServerSideProps = async ({ locale }) => {
  const queryClient = new QueryClient()

  await queryClient.prefetchQuery([SEO_TEXTS, locale], () =>
    sharedApi.getSEOText(locale ?? 'en')
  )
  await queryClient.prefetchQuery(TRANSLATE, () =>
    newLandingApi.getTranslate(locale ?? 'en')
  )

  return {
    props: {
      locale: locale,
      dehydratedState: dehydrate(queryClient)
    }
  }
}

const QuestionsPage = () => {
  return (
    <MainLayout isShowFooter title="FAQ">
      <QuestionsList />
    </MainLayout>
  )
}

export default QuestionsPage
